import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-repor-logs',
  templateUrl: './repor-logs.component.html',
  styleUrls: ['./repor-logs.component.scss']
})
export class ReporLogsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
